import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Modal from '../../../UniformComponents/Modal'
import Typography from '../../../UniformComponents/Typography'
import Input from '../../form/Input'
import Button from '../../../UniformComponents/Button'

const TemplateSettingsModal = ({ store }) => (
    <Modal
        show={store.templateSettingsModalOpen}
        onClose={store.closeTemplateSettingsModal}
    >
        <Typography type="h2">{i18n.t('templates.settings.title')}</Typography>

        <br />

        <hr />

        <br />

        <Input
            label={i18n.t('templates.templateName')}
            onBlur={store.setTemplateName}
            defaultValue={store.templateName}
            placeholder={i18n.t('templates.create.presentation.namePlaceholder')}
        />

        <br />

        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
                icon="far fa-save"
                label={i18n.t('save')}
                onClick={store.closeTemplateSettingsModal}
                cssClass="regular primary"
            />
        </div>
    </Modal>
)

export default observer(TemplateSettingsModal)
